import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { WindowRefService, SiteInfosService, Availibility, Ota, Room, Line, AvailibilityService, PanierService, SearchDispoService, ComparatorsService } from '@app/core';
import { ICombine } from '@app/shared';
import { Store } from '@ngrx/store';
import { Subscription, interval } from 'rxjs';
import { has, keys } from 'lodash';
import * as moment from 'moment';
import { StateOta } from '@app/state/ota/app.state-ota';
import { OtaActionType } from '@app/state/ota/app.actions-ota';

@Component({
    selector: 'app-extrablock',
    templateUrl: './extrablock.component.html',
    styleUrls: ['./extrablock.component.scss']
})
export class ExtrablockComponent implements OnInit, OnDestroy {
    loading = false;
    time: moment.Moment;
    private second: number;
    private subscription: Subscription;
    dataCombine: any = {
        room: null,
        line: null,
        adults: null,
        children: null,
        currentPrice: null,
        oldPrice: null,
        imageRoom: null,
        titleRoomByOta: null,
    };
    bestPriceCombine: any = {
        room: null,
        line: null,
        adults: null,
        children: null,
        currentPrice: null,
        oldPrice: null,
        imageRoom: null,
        titleRoomByOta: null,
    };
    private availibility$: Subscription;
    offreDispo = false;
    enabled: boolean = false;
    @Input() keybedSelected: string;
    @Input() bedding: Array<any>;

    constructor(private siteInfosService: SiteInfosService, private winRef: WindowRefService, private store: Store<any>, private availibilityService: AvailibilityService, private searchDispoService: SearchDispoService, private comparatorsService: ComparatorsService) { }

    ngOnInit() {
        this.enabled = this.winRef.appConfigSite.isGolleHotelFinder();
        if (this.enabled) {
            this.availibility$ = this.availibilityService.availibilitySubject.subscribe((response: Availibility) => {
                this.loading = true;
                if (!!response.extraDispo) {
                    this.store.select('appState').subscribe((data: StateOta) => {
                        if (data.type == OtaActionType.AddNew && !!data.response && !!data.response.enginesearch) {
                            if (data.response.enginesearch == "booking" || data.response.enginesearch == "backoffice") {
                                let ota: Ota = data.response;
                                let combineGoogle = ota.getMinEngineGoogleCache();
                                if (combineGoogle) {
                                    let [idRoom, idline, adults, children] = combineGoogle.indexSearch.split('_');
                                    let room = new Room(this.siteInfosService.getDataChambre(parseInt(idRoom))),
                                        line = new Line();
                                    this.dataCombine.oldPrice = combineGoogle.detailPrice.Ttc;
                                    this.dataCombine.adults = adults;
                                    this.dataCombine.children = children;
                                    this.dataCombine.room = room;
                                    this.dataCombine.imageRoom = this.generateUrlImage(this.dataCombine.room.getFirstImage());
                                    this.dataCombine.titleRoomByOta = this.comparatorsService.getTitleRoomByOta(this.dataCombine.room.id, "b");
                                    line.bindingData(this.availibilityService.getAvailibility().findLineBy(parseInt(idRoom), parseInt(idline)));
                                    line.addEngine({ combine: combineGoogle, alias: "b" }).enabled().updateMinEngine();
                                    this.dataCombine.line = line;
                                    this.dataCombine.currentPrice = combineGoogle.detailPrice.Ttc;
                                }
                            }
                            let bestPrice = this.searchDispoService.getMinPrices();
                            if (bestPrice) {
                                let indexArray = bestPrice.combine.indexSearch.split('_');
                                let room = new Room(this.siteInfosService.getDataChambre(parseInt(bestPrice.combine['code_room']))),
                                    line = new Line();
                                this.second = 10 * 60;
                                line.bindingData(this.availibilityService.getAvailibility().findLineBy(parseInt(indexArray[0]), parseInt(indexArray[1])));
                                line.addEngine(bestPrice).enabled().updateMinEngine();
                                this.bestPriceCombine.oldPrice = bestPrice.combine.detailPrice.Ttc;
                                this.bestPriceCombine.adults = bestPrice.combine['code_occupancy'];
                                this.bestPriceCombine.children = bestPrice.combine['code_children'];
                                this.bestPriceCombine.room = room;
                                this.bestPriceCombine.line = line;
                                this.bestPriceCombine.currentPrice = bestPrice.combine.detailPrice.Ttc;
                                this.bestPriceCombine.imageRoom = this.generateUrlImage(this.bestPriceCombine.room.getFirstImage());
                                this.bestPriceCombine.titleRoomByOta = this.comparatorsService.getTitleRoomByOta(this.bestPriceCombine.room.id, "b");
                                this.time = moment();
                                this.time.hour(0).minute(0).second(this.second).millisecond(0);
                                if (this.subscription) {
                                    this.subscription.unsubscribe();
                                }
                                this.subscription = interval(1000).subscribe(x => {
                                    this.second--;
                                    if (this.second >= 0) {
                                        this.time.subtract(1, 'seconds');
                                    } else {
                                        this.subscription.unsubscribe();
                                    }
                                });
                            }
                            this.loading = false;
                        }
                    });
                }
            });
        }
    }

    ngOnDestroy() {
        if (this.availibility$) {
            this.availibility$.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    /**
    * get taux de change
    * @returns number
    */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

    /**
    *
    * @returns string
    */
    generateUrlImage(image, size = "300X199"): string {
        return this.winRef.appConfigSite.hosteimageimg.concat("images/", this.winRef.appConfigSite.idEtab.toString(), "/upload/", size.toString(), "/", image);
    }

    selectCombine(room, line: Line, occupation, bed) {
        let myEle = "combine_".concat(line.engineSelected.combine.indexSearch);
        this.scrollTo(myEle);
    }

    scrollTo(myEle: string): void {
        const elementList = document.querySelectorAll("#" + myEle);
        if (!!elementList.length) {
            const element = elementList[0] as HTMLElement;
            element.scrollIntoView({ behavior: 'smooth' });
            document.getElementById(myEle).classList.add('highlight');
            setTimeout(() => {
                document.getElementById(myEle).classList.remove('highlight');
            }, 3000);
        }
    }

    // private getValbed(keyBed): Array<any> {
    //     let valBed = [];
    //     let bed = this.bedding.find((i) => i.key == keyBed);
    //     if (bed) {
    //         valBed = JSON.parse(JSON.stringify(bed.value));
    //     }
    //     return valBed;
    // }
}
